<template>
  <div v-if="loading === false" class="containerMembership">
    <b-container fluid v-if="($mq === 'mobile' || $mq === 'tablet')">
      <!-- header -->
      <HeaderBackMobile :backToHome="false" leftAction="menu"/>
      <main>

        <b-row v-if="hasBanner" style="margin-top:0px;min-height:300px;">
          <b-col style="padding:0px;position:relative">
            <img :src="getBannerPath()" style="max-width:100%;" />
            <div v-if="membershipRules" style="background-color:rgba(0,0,0,0.5);height:30px;position:absolute;bottom:70px;color:#ffffff;font-weight:bold;text-align:center;font-size:22px;width:100%;">
              Bem-vindo ao clube
            </div>
            <div v-if="membershipRules" style="background-color:rgba(0,0,0,0.5);position:absolute;bottom:0px;color:#ffffff;font-weight:500;text-align:center;font-size:17px;padding:10px;">
              {{membershipRules}}
            </div>
          </b-col>
        </b-row>
        <b-row style="margin-top:10px;" align-h="center" v-if="hasBanner && banners.length > 1">
          <b-col cols="1" v-for="(bbullet, idxb) in banners" v-bind:key="idxb">
            <div @click="updateBannerInterval(idxb)" :style="{backgroundColor: (idxb === bannerIdx ? getCssColor('primary_bt') : '#c0c0c0')}" style="width:14px;height:14px;border-radius:7px;margin:0px auto;">
            </div>
          </b-col>
        </b-row>

        <b-row style="margin-top:20px;
          font-size: 18px;
          color: #121C2A;">
          <b-col>Prêmios</b-col>
        </b-row>
        <b-row style="margin-top:10px;">

          <!-- prize card -->
          <b-col cols="6" v-for="(prize, idxp) in prizes" v-bind:key="idxp" :class="{colLeftNoPadding: idxp % 2 === 0, colRightNoPadding: idxp % 2 !== 0}">
            <div class="prizeProductCard">
              <b-row>
                <b-col cols="12" style="height:140px;text-align:center;">
                  <img @click="$router.push({path:'/membership_prize/' + prize.id})" :src="getPrizeImagePath() + prize.photos[0].id" style="max-width: calc(100% - 20px); max-height: 130px;" />
                </b-col>
                <b-col cols="12">
                  <div style="height:3px;border-top: 1px solid #D9D9D9;margin-bottom:16px;width:100%"></div>
                </b-col>
                <b-col cols="12" style="
                  font-style: normal;
                  font-weight: normal;
                  line-height: 24px;
                  font-size: 17px;
                  letter-spacing: 0.15px;
                  color: #424242;
                ">
                  {{prize.price_points}} pontos
                </b-col>
                <b-col cols="12" style="
                  margin-top:8px;
                  margin-bottom:8px;
                  font-style: normal;
                  font-weight: 300;
                  line-height: 18px;
                  font-size: 14px;
                  letter-spacing: 0.25px;
                  height:54px;
                  color: #424242;
                  overflow: hidden;
                  text-overflow: ellipsis;
                ">
                  {{prize.name}}
                </b-col>
                <b-col cols="12" :style="{color: getCssColor('primary_bt')}" style="
                  margin-bottom:8px;
                  font-style: normal;
                  font-weight: normal;
                  line-height: 24px;
                  font-size: 17px;
                  letter-spacing: 0.15px;
                ">
                  <div @click="$router.push({path:'/membership_prize/' + prize.id})">Detalhes</div>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <!-- end card -->
          
        </b-row>

        <!-- spacing for fixed-->
        <b-row style="margin:60px;"></b-row>
      </main>
      <footer style="position:relative;">
        <!-- fixed down menu -->
        <MembershipNavigation selected="prizes"/>
      </footer>
    </b-container>
  </div>
  <div v-else>
    <InnerLoading/>
  </div>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import MembershipNavigation from '@/components/MembershipNavigation'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import colors from '@/mixins/colors'
import MembershipConn from '@/connection/membership'
import membershipMixin from '@/mixins/membershipMixin'
import UserConn from '@/connection/user'
export default {
  data () {
    return {
      prizes: [],
      loading: true,
      hasBanner: false,
      banners: [],
      banner: null,
      membershipRules: null,
      bannerIdx: 0,
      bannerInterval: null
    }
  },
  mixins: [colors, membershipMixin],
  components: {InnerLoading, HeaderBackMobile, MembershipNavigation},

  async mounted () {
    if (UserConn.isLoggedIn()) {
      this.getConfigs()
      this.getPrizes()
    } else {
      this.$store.state.registerLoginOrigin = 'membership_prizes'
      this.$router.push({path: '/login'})
    }
  },

  methods: {
    async getConfigs () {
      let result = await MembershipConn.getConfigs()
      if (!result.error) {
        if (result.banners.length) {
          this.hasBanner = true
          this.banner = result.banners[0]
          this.banners = result.banners
          this.membershipRules = result.membership_rules_text
          if (this.banners.length > 1) {
            this.bannerInterval = setInterval(this.changeBanner, 7000)
          }
        }
      }
    },

    changeBanner () {
      if (this.bannerIdx + 1 === this.banners.length) {
        this.bannerIdx = 0
      } else {
        this.bannerIdx = this.bannerIdx + 1
      }
      this.banner = this.banners[this.bannerIdx]
    },

    updateBannerInterval (idxBanner) {
      clearInterval(this.bannerInterval)
      this.bannerInterval = null
      this.bannerIdx = idxBanner
      this.banner = this.banners[this.bannerIdx]
      this.bannerInterval = setInterval(this.changeBanner, 7000)

    },

    getBannerPath () {
      if (this.$mq === 'mobile') {
        return this.getMembershipBannerImagePath() + this.banner.xs
      } else if (this.$mq === 'tablet') {
        return this.getMembershipBannerImagePath() + this.banner.sm
      } else {
        return this.getMembershipBannerImagePath() + this.banner.md
      }
    },

    async getPrizes () {
      let result = await MembershipConn.getPrizes()
      if (!result.error) {
        this.prizes = result
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
.containerMembership {
  background-color: #FAFAFA;
  min-height: 100vh;
}

.prizeProductCard {
  padding:10px;
  background-color:#ffffff;
  border-radius: 4px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  height:300px;
}

.colLeftNoPadding {
  padding-left:8px;
  padding-right:4px;
  margin-top:10px;
}

.colRightNoPadding {
  padding-left:4px;
  padding-right:8px;
  margin-top: 10px;
}
</style>
